import { useNavigate } from 'react-router-dom'
import handleNavigation from './handleNavigate'
import { useState } from 'react'
import { Modal } from '@nxtvid/component-library'


const ListOfCharacters = ({characters, setCharacters, setModalFunctionParams, setModalMessage, setModalFunction}) =>{
    let characterList = []
    const navigate = useNavigate()
    const settings_icon = require('../Images/settings-icon.png')
    // Modal States
        const [isModalOpen, setIsModalOpen] = useState(false)
        const [modalType, setModalType] = useState('confirm')
        const [modalSize, setModalSize] = useState('medium')
        const [modalTitle, setModalTitle] = useState('')
        const [modalDescription, setModalDescription] = useState('' )
        const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
        const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
        const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
        const [modalCancelButtonText, setModalCancelButtonText] = useState('')


    const handleDeleteCharacter = (selectedCharacters) =>{
        const saveToDb = async (allCharacters) =>{
            
            try{
                const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
                const response = await fetch(`${API_BASE_URL}/saveCharacters`, {
                    method:'POST',
                    credentials: 'include',
                    headers:{
                        'Content-Type': 'application/json',
                        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
                    },
                    body:JSON.stringify({allCharacters}),
                });
                const result = await response.json();
                console.log(result)
            } catch(error){
                console.error('Error: ', error)
            }
        }
    
        const tempCharacters = [...selectedCharacters]
        saveToDb(tempCharacters)
        setCharacters(tempCharacters)
        setIsModalOpen(false)
        
    }

    const handleConfirmDeleteCharacter = (character) => {
        setModalOnConfirm(()=>()=>handleDeleteCharacter(characters.filter(item => item.imageId!==character.imageId))); 
        setModalOnCancel(()=>()=>setIsModalOpen(false));
        setModalTitle('Delete Character')
        setModalDescription('Are you sure you want to delete this character? This action is irreversable.'); 
        setIsModalOpen(true)
        setModalCancelButtonText('Cancel')
        setModalConfirmButtonText('Delete')
        setModalSize('medium')
        setModalType('confirm')
    }

    const handleConfirmAddCharacter = () => {
        setModalOnConfirm(()=>()=>handleNavigation({path:"/CharacterCreation", navigate})); 
        setModalOnCancel(()=>()=>setIsModalOpen(false));
        setModalDescription('Are you sure you want to add a new character? If you leave this page, your work will not be saved.'); 
        setIsModalOpen(true)
        setModalTitle('Add Character')
        setModalCancelButtonText('Cancel')
        setModalConfirmButtonText('Add')
        setModalSize('medium')
        setModalType('confirm')
    }

    characterList = characters.map(character =>{
        if(character.name!=="None"){
            return(
            <div className="characterCard" id={"character-" + character.imageId}>
                <div className="characterCard-details">
                    <div className="character-name-container">
                        <p className="characterCard-name">{character.name}</p>
                        <div className="settings-container">
                        <img alt="settings icon" className="settings-icon" src={settings_icon}/>
                        <div className="character-settings">
                            <p className="storyboard-setting" onClick={()=>handleConfirmDeleteCharacter(character)}>Delete Character</p>
                        </div>
                        </div>
                    </div>
                    <p className="characterCard-detail">Age: {character.age}</p>
                    <p className="characterCard-detail">Gender: {character.gender}</p>
                    <p className="characterCard-detail">Ethnicity: {character.ethnicity}</p>
                </div>
                <div className="characterCard-img-container">
                <img alt="Character" className="characterCard-img" src={character.image}/>
                </div>
                
            </div>
            )
            
        }
        return null
    })
    characterList.push(
        <div className="characterCard" id="add-character-card" onClick={handleConfirmAddCharacter}>
            <p className="add-character-text">Add Character</p>
            <div className="add-character-container">
                <p className="add-character-text">+</p>
            </div>
        </div>
    )
    return (
        <div className="characterList">
            {isModalOpen ? <Modal size={modalSize} type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : <p></p>}
            {characterList}
        </div>)
}

export default ListOfCharacters